export const timezoneOffset = 7 * 3600

export const baseChartOptions = {
  layout: {
    background: { type: 'solid', color: 'transparent' },
  },
  timeScale: {
    visible: false,
    secondsVisible: false,
    borderVisible: false,
  },
  rightPriceScale: {
    minimumWidth: 70,
  },
  localization: {
    locale: 'vi-VN',
    dateFormat: 'dd MMMM \'yy',
  },
}

export const candleSeriesOptions = {
  upColor: 'green',
  downColor: 'red',
  priceLineVisible: false,
}

export function priceLine(price, lineWidth = 1) {
  return {
    price,
    color: 'black',
    axisLabelVisible: false,
    lineWidth,
  }
}
